export const ALIGNMENT_CLASSES = {
  start: '',
  baseline: 'private-checkbox--align-baseline',
  center: 'private-checkbox--align-center',
  end: 'private-checkbox--align-end'
};
export const SIZE_OPTIONS = {
  default: '',
  sm: 'private-checkbox--small'
};